import select from "../../dom/modules/select.js";
select("form.newsletter-form", document.body).forEach((form) => {
  form.addEventListener("submit", (e) => {
    e.preventDefault();

    var input = form.querySelector('[name="email"]');
    form.querySelectorAll(".error-label").forEach((label) => {
      label.remove();
    });

    let data = new FormData();
    data.append(
      "csrfmiddlewaretoken",
      form
        .querySelector('input[name="csrfmiddlewaretoken"]')
        .getAttribute("value")
    );
    data.append("email", input.value);
    let url = form.getAttribute("action");
    fetch(url, {
      method: "POST",
      body: data,
      credentials: "same-origin",
    })
      .then((response) => response.json())
      .then((d) => {
        if (d.success) {
          form.innerHTML = d.message;
        } else {
          var label = document.createElement("label");
          label.setAttribute("for", form.querySelector('[name="email"]').id);
          label.classList.add("error-label");
          label.innerHTML = d.message;
          input.before(label);
        }
      })
      .then();
  });
});
